export default __webpack_public_path__ + "static/media/120788.11ea276f.jpg";